module.exports = __webpack_public_path__ + "static/media/README.25a9fe91.md";